<template>
	<div class="">
		<english-header></english-header>
		<EnPageNavigater></EnPageNavigater>
		<div class="en_contain">
			<!-- 文章列表 -->
			<cms-article-list v-if="type=='list'" :pid="articlePid" :limit="pageSize" :page="currentPage"
				class="article-list" @loaded="articleLoaded">
				<template slot-scope="{ list }">
					<template>
						<div class="article-item" v-for="item in list" :key="item.id" @click="itemClick(item)">
							<img :src="item.cover" alt="" class="article-img">
							<div class="article-content">
								<div class="artile-title">{{ item.title }}</div>
								<div class="time">{{formateDate(item.createTime) }}</div>
								<div class="detail" :class="isIE ? 'classie' : ''">{{ item.intro }}</div>
							</div>
						</div>
						<!-- 底下分页器做个参数，可有可无 -->
						<div class="page">
							<el-pagination background layout="prev, pager, next" ref="pagination" :page-size="pageSize"
								:total="total" :current-page="listPage" @current-change="pageChange">
							</el-pagination>
						</div>
					</template>
				</template>
			</cms-article-list>

			<!-- 详情页 富文本-->
			<div class="artile-detail" v-if="type=='detail'">
				<div class="title">{{ title }}</div>
				<div class="time">{{ time }}</div>
				<div v-viewer="options" class="richtext" ref="richEl"></div>
			</div>
			<!-- 图片列表-->
			<cms-article-list v-if="type=='picture'||type=='video'" :pid="articlePid" :limit="pageSize"
				:page="currentPage" @loaded="articleLoaded" style="position: relative;width: 100%;">
				<template slot-scope="{ list }">
					<template>
						<div class="picture-list">
							<div class="picture-item" :class="isIE ? 'classie' : ''" v-for="item in list" :key="item.id" @click="itemClick(item)">
								<div class="img-top">
									<cms-image :src="item.cover"></cms-image>
									<div class="mask" v-if="type=='video'"></div>
								</div>
								<div class="hotel-name">{{ item.titleEn }}</div>
							</div>
						</div>
						<!-- 底下分页器做个参数，可有可无 -->
						<div class="page">
							<el-pagination background layout="prev, pager, next" ref="pagination" :page-size="pageSize"
								:total="total" :current-page="listPage" @current-change="pageChange">
							</el-pagination>
						</div>
					</template>
				</template>
			</cms-article-list>
			<div class="correlation" v-if="type=='list'||type=='detail'">
				<cms-article-list :pid="$cid.video" :limit="1" :page="1">
					<template slot-scope="{ list }">
						<div class="correlation-item" v-for="item in list" :key="item.id" @click="videoClick(item)">
							<div class="title">Video of Mount Emei</div>
							<div class="img-item">
								<div class="img-top">
									<cms-image :src="item.cover"></cms-image>
									<div class="mask"></div>
								</div>
								<div class="hotel-name">{{ item.titleEn }}</div>
							</div>
						</div>
					</template>
				</cms-article-list>
				<cms-article-list :pid="$cid.picture" :limit="1" :page="1">
					<template slot-scope="{ list }">
						<div class="correlation-item" v-for="item in list" :key="item.id" @click="picClick(item)">
							<div class="title">Scenery of Mount Emei</div>
							<div class="img-item">
								<div class="img-top">
									<cms-image :src="item.cover"></cms-image>
								</div>
								<div class="hotel-name">{{ item.titleEn }}</div>
							</div>
						</div>
					</template>
				</cms-article-list>
			</div>
		</div>
		<english-footer />
		<CmsVideoPlayer :src="videoSrc" :visible.sync="visible" :poster="poster" />
		<CmsFramePlayer :src="liveSrc" :visible.sync="liveVisible" />
	</div>
</template>

<script>
  import moment from 'moment';
	import '~/views/less/english/list.css'
	import '~/views/less/english/mobileEn.css'
	import CmsVideoPlayer from "~/components/cms/CmsVideoPlayer.vue";
	import CmsFramePlayer from "~/components/cms/CmsFramePlayer.vue";
	import {
		getArticle,
		getArticles,
		getNotice,
		getNotices,
		getArticleAdjacent
	} from '~/api/CmsApi'
	export default {
		components: {
			CmsVideoPlayer,
			CmsFramePlayer
		},
		props: {
			// list列表，detail详情，picture图片,video视频
			type: {
				type: String,
				default: ''
			},
			// 当前页面一页加载条数，文章默认4条或6条，图片一页加载6条
			pageSize: {
				type: Number,
				default: 6
			},
			// 页面标题
			pageTitle: {
				type: String,
				default: ''
			},
			// 父栏目id
			pid: {
				type: String,
				default: ''
			},
			/**
			 * 排序方式 0:时间倒序 1:sort值正序 2:ext1倒序（此时ext1为日期）
			 */
			sortBy: {
				type: [String, Number],
				default: ''
			},
			currentPage: {
				type: Number,
				default: 1
			}
		},
		mounted() {
			var page = 0;
			this.currentPage = page || Number(this.$route.query.page) || 1;
			this.articlePid = this.pid
			if (this.type == 'detail') {
				this.getArticle(this.articlePid);
			}
			if (document.documentMode)
				this.isIE = true;
		},
		data() {
			return {
				defultImg: require('~/views/img/images_en/home_25.jpg'),
				articlePid: null,
				total: 0,
				title: '',
				time: '',
				options: {
					inline: false,
					button: true,
					navbar: true,
					title: false,
					toolbar: true,
					tooltip: true,
					movable: true,
					zoomable: true,
					rotatable: true,
					scalable: true,
					transition: true,
					fullscreen: true,
					keyboard: true,
					// url: 'data-source',
				},
				videoSrc: '',
				visible: false,
				poster: '',
				liveSrc: '',
				liveVisible: false,
				tabIndex: 0,
				defaultTabId: '666',
				isIE: false
			}
		},
		methods: {
			getArticle(id) {
				this.articleLoading = true;
				getArticle(id).then(res => {
					if (res.code === 0) {
						this.renderArticle(res.data);
					}
					this.articleLoading = false;
				})
			},

			/**
			 * 渲染文章内容
			 * @param data
			 */
			renderArticle(data) {
				this.title = data.title;
				this.$refs.richEl.innerHTML = data.content;
				this.time = data.createTime.slice(0, 10)
			},
			articleLoaded(list, total) {
				this.total = total;
				this.listPage = this.currentPage;
			},
			pageChange(page) {
				// const base = this.$router.options.base;
				// let path = this.$route.path;
				// if (base) {
				//   path = base + path.substring(1);
				// }
				//
				// const query = this.$route.query || {};
				// query.page = page;
				// let str = '';
				// for (const key in query) {
				//   str += `&${key}=${query[key]}`;
				// }
				// str = str.substring(1);
				//
				// this.$router.push({
				//   path: `${path}?${str}`
				// })
				this.currentPage = page;
			},
			itemClick(item) {
				localStorage.setItem('EnSubPageColumn', JSON.stringify({
					path: window.location.pathname,
					tab: this.articlePid,
					page: this.currentPage
				}));
				this.$emit('article-click', item);
			},
			videoClick(data) {
				if (this.tabIndex === 0) {
					this.videoSrc = data.ext1;
					this.poster = data.cover;
					this.$nextTick(() => {
						this.visible = true;
					})
				} else {
					this.liveSrc = data.ext1;
					this.$nextTick(() => {
						this.liveVisible = true;
					});
				}
			},
			picClick(data) {
				const image = data.cover;
				this.$viewerApi({
					images: [image],
				})
			},
      formateDate(time){
        time =  moment(new Date(time)).format('DD/MM/YYYY')||""
      
        return time
      },
		}
	}
</script>

<style>
	body {
		background-color: #fffaee;
	}
</style>


// WEBPACK FOOTER //
// src/components/entemplate/listTemplate.vue